<div>
  <div class="l-row">
    <div class="l-col--side l-col--sideNavigation l-col--sideLeft"></div>
    <div class="l-col--main">
      <div class="c-article">
        <h1 class="c-article__title">
          Luomun tarina-verkkokaupan toimitusehdot
        </h1>
        <div class="c-article__body">
          <p>P&auml;ivitetty 23.11.2020</p>
          <h2>1. Yleist&auml;</h2>
          <p>
            Tervetuloa Luomun tarina-verkkokauppaan! Nämä ehdot ovat Seulo
            Palvelut Oy:n/Luomun tarina (jäljempänä ”Yritys” ta “Kauppias”)
            -verkkokaupan (jäljempänä ”Verkkokauppa”) sopimusehdot (jäljempänä
            ”Ehdot”), joita sovelletaan Verkkokaupasta ostettavien tuotteiden
            Kauppiaan ja asiakkaan (jäljempänä ”Asiakas”) välillä.
          </p>
          <h2>2. Verkkokaupassa asiointi</h2>
          <p>
            Verkkokaupassa voi tehdä ostoksia rekisteröityneenä. Alle 18-vuotias
            voi tehdä ostoksia vain vanhempansa tai muun laillisen huoltajansa
            etukäteissuostumuksella.
          </p>
          <p>
            Asiakas sitoutuu antamaan itseään koskevat tiedot oikeina, ja
            Asiakas vastaa tietojen oikeellisuudesta. Jotta Yritys voi palvella
            Asiakasta parhaalla mahdollisella tavalla, rekisteröityneen
            Asiakkaan tulee viivytyksettä päivittää tietonsa asiakastilinsä
            kautta tai ilmoittaa tietojensa muuttumisesta Yritykselle.
          </p>
          <p>
            Asiakkaalla on oltava toimiva sähköpostiosoite ja puhelinnumero.
            Tilausvahvistus/kuitti toimitetaan Asiakkaalle vain sähköpostitse,
            ja Asiakas näkee tilauksensa myös asiakastilinsä kautta.
            Rekisteröidyttyään asiakas saa käyttöönsä henkilökohtaiset
            käyttäjätunnukset. Asiakas vastaa tunnuksillaan tapahtuvasta
            asioinnista Verkkokaupassa. Mikäli Asiakas havaitsee tai epäilee,
            että hänen tunnuksensa ovat paljastuneet tai joutuneet sivullisen
            haltuun taikka hänen tunnuksiaan käytetään väärin, Asiakas on
            velvollinen ilmoittamaan asiasta välittömästi Verkkokaupalle.
            Verkkokaupalla on oikeus oma-aloitteisesti jäädyttää Asiakkaan
            tunnukset, mikäli Verkkokauppa epäilee, että tunnuksia
            väärinkäytetään.
          </p>
          <h2>3. Henkilötietojen käsittely</h2>
          <p>
            Kauppias käsittelee henkilötietoja kulloinkin voimassa olevan
            henkilötietolainsäädännön sallimalla ja velvoittamalla tavalla
            toimien henkilörekisterien rekisterinpitäjänä. Asiakkaan tietoja
            käsitellään tietosuojaselosteessa kuvatuin tavoin.
          </p>
          <h2>4. Tuotteiden ja palveluiden tilaaminen</h2>
          <p>
            Tuotteiden ja palveluiden (jäljempänä yhdessä ”Tuotteet”) tilaaminen
            tapahtuu siten, että Asiakas valitsee haluamansa Tuotteet
            ostoskoriin, minkä jälkeen Asiakas vie tilauksen loppuun
            Verkkokaupan ohjaamalla tavalla. Asiakas voi muuttaa ostoskorinsa
            sisältöä tilauksen maksamiseen saakka. Asiakasta kehotetaan
            tarkistamaan huolellisesti tilauksensa sisältö ennen tilauksen
            loppuun viemistä. Asiakasta sitova tilaus syntyy, kun Asiakas on
            lähettänyt tilauksensa. Asiakas saa tilauksesta
            tilausvahvistuksen/kuitin antamaansa sähköpostiosoitteeseen.
          </p>
          <h2>5. Toimitusalueet</h2>
          <p>
            Luomun tarina:n kulloinkin valittavissa olevat kylmäkuljetuksen
            toimitusalueet ovat nähtävillä Verkkokaupan Info-sivulla.
            Toimitusalueet ovat kaikki Manner-Suomessa, vaikka toimitusaluetta
            määrittävä postinumero kattaisi myös saaristoaluetta, minne ei ole
            kiinteää ajoyhteyttä.
            <br /><br />
            Pakettikuljetukset toimitetaan koko Suomen alueelle Ahvenanmaata
            lukuunottamatta.
          </p>
          <h2>6. Hinnat</h2>
          <p>
            Tilauksen kokonaishinta koostuu Tuotteiden hinnoista,
            toimitusmaksusta, mahdollisista palvelumaksuista ja mahdollisista
            maksutapaan liittyvistä kuluista.
          </p>
          <p>
            Tuotteet veloitetaan tilaushetkellä voimassa olevan hinnan
            perusteella. Tuotteiden hinnat ovat voimassa toistaiseksi tai tuote-
            / palvelutiedoissa erikseen ilmoitettuna aikana. Tuotteiden hinnat
            sisältävät arvolisäveron. Tuotteiden hinnat eivät sisällä
            toimituskuluja, vaan ne ilmoitetaan erikseen tilauksen yhteydessä ja
            tilausvahvistuksessa/kuitissa.
          </p>
          <p>
            Tilatessaan Asiakas valitsee tilattavan Tuotteen ja määrittää
            Tuotteen määrän joko kappalemääräisesti tai vaihtuvamääräisesti
            painon mukaan (kg-hinnoiteltu). Vaihtuvamääräisiä Tuotteita
            toimitettaessa Luomun tarina kerää mahdollisimman tarkkaan tilatun
            määrän kyseistä Tuotetta. Tuotteiden luonteesta ja rakenteesta
            riippuen toimitusmäärä voi kuitenkin poiketa tilausmäärästä, jolloin
            tuotteen lopullinen hinta määräytyy Tuotteen toteutuneen
            toimitusmäärän mukaan. Arviopainoa pienemmän tuotteen osalta liikaa
            veloitettu summa palautetaan Luomun tarina-tilille. Asiakastilin
            saldon voi käyttää seuraavan tilauksen maksamisessa tai saldon voi
            siirrättää omalle pankkitilille. Kiinteämääräiset tuotteet myydään
            tilaushetkellä voimassa olevalla kappalehinnalla. Vaihtuvamääräiset
            tuotteet myydään tilaushetkellä voimassa olevalla yksikköhinnalla.
          </p>
          <p>
            Kauppias pidättää oikeuden muuttaa Tuotteiden hintoja. Kauppias
            pyrkii siihen, että Verkkokaupassa esitetyt hinnat olisivat aina
            oikeat ja ajantasaiset, mutta ei myönnä mitään takuuta hintojen
            oikeellisuudesta. Mikäli Verkkokaupassa ollut virheellinen
            hintatieto poikkeaa huomattavasti todellisesta hinnasta, on
            poikkeuksellisen alhainen verrattuna yleiseen hintatasoon tai virhe
            on muutoin sillä tavoin selvä, että Asiakkaan olisi pitänyt ymmärtää
            kyseessä olevan virhetiedon, virheellinen hinta ei sido Yrityksen
            verkkokauppaa.
          </p>
          <h2>7. Tuotteiden saatavuus</h2>
          <p>
            Yritys ei voi myöntää mitään takuita Verkkokaupassa myytävien
            Tuotteiden saatavuudesta tai riittävyydestä. Osa Verkkokaupan
            tuotteista on ns. sesonkituotteita tai muutoin sellaisia Tuotteita,
            joita valmistetaan vain rajallinen määrä. Vakiovalikoimaankin
            kuuluvat Tuotteet saattavat olla tilapäisesti loppu esimerkiksi
            tuotannollisten syiden vuoksi. Kauppias pyrkii pitämään
            Verkkokaupassa ajantasaiset ja oikeat tiedot saatavilla olevista
            tuotteista.
          </p>
          <p>
            Mikäli tilattu Tuote, joka on Verkkokaupassa näkynyt saatavilla
            olevana tuotteena, on tilapäisesti loppunut siten, että Tuotetta ei
            saada toimitettua tilattuun toimitusajankohtaan Tuote jätetään
            toimittamatta ja toimitusluetteloon merkitään Tuotteen puuttuminen,
            sekä Tuotteen veloitus hyvitetään.
          </p>
          <h2>8. Tilausvahvistus/kuitti</h2>
          <p>
            Asiakkaalle lähetetään onnistuneen tilauksen jälkeen sähköpostitse
            tilausvahvistus/kuitti, joka sisältää tilauksen keskeiset tiedot.
            Asiakkaan tulee tarkistaa, että tilausvahvistukseen merkityt tiedot
            tilauksen sisällöstä ovat oikeat. Verkkokaupalla on oikeus olla
            hyväksymättä tilausta perustellusta syystä.
          </p>
          <h2>9. Toimitustavat ja toimituksen vastaanotto</h2>

          <p>Tarjoamme asiakkaillemme seuraavat toimitustavat:</p>
          <h3>9.1 Kylmäkuljetus rajatuilla postinumeroalueilla</h3>
          <p>
            Tuotteet toimitetaan Asiakkaalle kotiinkuljetuksena Asiakkaan
            ilmoittamaan toimitusosoitteeseen. Kotiinkuljetuksien kulloinkin
            valittavissa olevat toimituspäivät ja kellonajat ovat nähtävillä
            Verkkokaupan info-sivulla. Arkipyhien ja muiden poikkeusajankohtien
            osalta sovelletaan kulloinkin Verkkokaupassa ilmoitettavia
            poikkeuksellisia tilausmääräpäiviä.
          </p>
          <p>
            Mikäli Asiakas tilauksen tehtyään toivoo muutosta toimitusaikaan,
            tulee hänen olla yhteydessä Luomun tarina:n asiakaspalveluun ja
            tiedustella, onko toivottu muutos mahdollinen. Luomun tarina pyrkii
            toteuttamaan asiakkaan muutostoiveet, muttei voi taata sitä mm.
            Kuljetusaikataulujen ja-reittien vuoksi.
          </p>

          <p>
            Mikäli tilauksen toimittaminen viivästyy, Luomun tarina pyrkii
            ilmoittamaan Asiakkaalle viivästyksestä Asiakkaan antamia
            yhteystietoja käyttäen ja antamaan Asiakkaalle arvion
            toimitusajankohdasta.
          </p>

          <p>
            Asiakas sitoutuu järjestämään toimituksen vastaanoton niin, että
            Asiakas tai hänen valtuuttamansa henkilö on vastaanottamassa
            toimitusta tilauksen yhteydessä määritetyllä aikavälillä. Luomun
            tarina takaa kylmäsäilytystä vaativien tuotteiden kylmäketjun
            säilymisen tilauksen vahvistetun toimituksen aikavälin ajaksi ja
            kunnes toimitus on luovutettu Asiakkaalle tai jätetty Asiakkaan
            ilmoittamaan paikkaan, mikäli asiakas on kirjallisesti tai
            sähköisesti jättöön luvan antanut. Luomun tarina ei ole vastuussa
            siitä, mikäli Asiakas ei hoida kylmäsäilytystä vaativia tuotteita
            asianmukaiseen kylmäsäilöön sen jälkeen, kun toimitus on luovutettu.
          </p>

          <p>
            Jos Asiakas tai hänen valtuuttamansa henkilö ei ole paikalla
            vastaanottamassa toimitusta sovittuna aikana, voi kuljettaja jättää
            toimituksen ovelle, mikäli asiakas on tähän luvan antanut. Jos
            vastaanottaja ei ole paikalla eikä lupaa jättöön ole annettu,
            palautuu toimitus takaisin keräilyterminaaliin. Mikäli saman päivän
            aikana saadaan Asiakas tavoitettua ja toimitus toimitettua,
            veloitetaan Asiakkaalta ylimääräisestä toimituskäynnistä 20euron
            lisämaksu, minkä Asiakas on velvollinen maksamaan. Mikäli Asiakasta
            ei saada kiinni saman päivän aikana, Luomun tarina:lla on oikeus
            veloittaa koko tilauksen hinta toimitus- ja mahdollisine
            palvelumaksuineen, vaikkei toimitusta saada tehtyä. Luomun tarina
            säilyttää ei-pilaantuvia tuotteita 20 vuorokauden ajan toimitus
            yrityksestä tiloissaan, josta Asiakas voi ne käydä noutamassa.
            Vaihtoehtoisesti Asiakas voi pyytää uutta toimitusta, josta Asiakas
            on velvollinen maksamaan 20 euron lisämaksun.
          </p>

          <p>
            Luomun tarina ei vastaa siitä, jos tilauksen toimittaminen viivästyy
            tai tilausta ei pystytä toimittamaan sen vuoksi, että Asiakas on
            ilmoittanut virheelliset yhteystiedot Luomun tarina:lle tai
            laiminlyönyt ilmoittaa yhteystietojensa muuttumisen, taikka ei ole
            paikalla sovittuna toimitusajankohtana eikä häntä tavoiteta.
          </p>

          <h3>9.2 Pakettitoimitus</h3>
          <p>
            Keräämme ja postitamme tuotteita jokaisena arkipäivänä. Postikulut
            ovat samat paketin koosta riippumatta. Paketit lähtevät meiltä
            pääsääntöisesti 1-2 arkipäivän sisällä tilauksesta. Joskus tilausten
            käsittely saattaa kuitenkin ruuhkautua ja toimitusajat voivat hiukan
            venyä. Toimituskulut sisältävät posti- ja pakkauskulut. Toimitamme
            tilaukset Postin pakettina, jota voit seurata lähetystunnuksella,
            jonka saat tilausvahvistuksen mukana.
          </p>
          <p>
            Kun paketti on saapunut postitoimipaikkaasi, saat siitä Postilta
            ilmoituksen. Huomaathan, että Posti ilmoittaa pakettien saapumisista
            ensisijaisesti vain tekstiviestillä. Paperinen saapumisilmoitus
            lähetetään vain siinä tapauksessa, jos vastaanottaja ei ole
            ilmoittanut puhelinnumeroa tai sähköpostiosoitetta. On siis tärkeää,
            että tilatessasi syötät ajan tasalla olevat yhteystiedot. Lähetystä
            säilytetään noutopisteessä 7 vuorokautta, jonka jälkeen se
            palautetaan lähettäjälle.
          </p>

          <h3>9.3 Postin kotiinkuljetus</h3>

          <p>
            Posti sopii toimitusajan vastaanottajan kanssa puhelimitse. Jos
            vastaanottajaa ei tavoiteta puhelimitse, tälle jätetään
            yhteydenottopyyntö. Paketit jaetaan vastaanottajan osoitteeseen
            sisälle asti, ulko-oven välittömään läheisyyteen. Mikäli
            vastaanottajaa ei tavoiteta, paketti toimitetaan noudettavaksi
            lähimpään postitoimipaikkaan. Pakettia säilytetään postissa 7
            vuorokautta, jonka jälkeen se palautetaan lähettäjälle.
          </p>

          <h2>10. Toimitusmaksu</h2>
          <p>
            Sovellettava toimitusmaksu näytetään lisäksi Asiakkaalle tilauksen
            yhteydessä ennen kuin asiakas vahvistaa tilauksen.
          </p>
          <p>Pakettikuljetuksen hinnat ovat samat tilauksen koosta riippuen.</p>
          <h2>11. Maksaminen</h2>
          <p>
            Asiakas valitsee maksutavan tilaushetkellä Asiakkaalle tarjolla
            olevista vaihtoehdoista. Tuotteet ja niiden toimituskulut ja
            mahdolliset palvelumaksut maksetaan tilauksen yhteydessä
            Verkkokaupassa ilmoitetuilla maksutavoilla.
          </p>
          <p>
            Yritys voi veloittaa eri maksutavoista aiheutuvia kuluja kulloinkin
            voimassa olevan hinnaston mukaisesti. Maksutavan mahdollinen
            kustannus on nähtävissä maksutavan valintahetkellä.
          </p>
          <p>
            Verkkokaupassamme voit maksaa verkkopankeilla, maksukorteilla,
            laskulla tai osamaksulla sekä mobiilimaksuilla. Käytettävissä ovat
            seuraavat maksutavat:
          </p>
          <ul>
            <li>
              Verkkopankit: Osuuspankki, Nordea, Danske Bank, Oma Säästöpankki,
              Säästöpankki, Aktia, POP Pankki, S-Pankki, Handelsbanken,
              Ålandsbanken
            </li>
            <li>
              Maksukortit: Visa-, Visa Debit-, Visa Electron-, MasterCard- ja
              Debit MasterCard -kortit
            </li>
            <li>Mobiilimaksut: Pivo, Siirto, MobilePay ja Masterpass</li>
            <li>
              Enterpay Lasku yrityksille, Jousto lasku ja osamaksu
              yksityishenkilöille
            </li>
          </ul>
          <p>
            Verkkokaupan maksuvälittäjänä toimii Maksukaista (Paybyway Oy,
            y-tunnus 2486559-4, jäljempänä ”Maksupalvelun tarjoaja”), joka on
            rekisteröity Finanssivalvonnan ylläpitämään maksulaitosrekisteriin.
          </p>
          <p>
            Tietoja Maksupalvelun tarjoajan henkilötietojen käsittelystä
            maksupalvelun käyttäjille löytyy Maksupalvelun tarjoajan
            verkkosivuilta.
          </p>
          <p>
            Kaikissa maksutavoissa noudatetaan maksutavan tuottajan
            (Maksupalvelun tarjoajan alihankkija tai kumppani, esimerkiksi
            Nordea, Collector tai MobilePay) sopimusehtoja ja rajoituksia.
            Maksutapa kohtaiset sopimusehdot ovat saatavilla kyseisen maksutavan
            tuottajan omilla verkkosivuilla. Maksutapoihin liittyvät mahdolliset
            erityisehdot ovat saatavilla Maksupalvelun tarjoajan verkkosivuilla.
          </p>
          <p>
            Maksamiseen siirrytään Maksupalvelun tarjoajan verkkopalvelun
            kautta. Tiliotteella ja laskulla maksun saajana näkyy Maksukaista /
            Paybyway Oy.
          </p>
          <p>
            Maksaminen on turvallista, sillä kaikki maksutapahtumaa koskevat
            tiedot välitetään salattua yhteyttä käyttäen niin ettei kukaan
            ulkopuolinen taho näe maksutapahtuman tietoja. Yrityksellämme ei ole
            pääsyä korttitietoihin eikä maksukortin tietoja tallenneta
            järjestelmiimme. Veloitus suoritetaan tilaushetkellä.
          </p>
          <h2>12. Tuotteiden tarkastaminen ja reklamaatio</h2>
          <p>
            Asiakkaan tulee toimituksen vastaanotettuaan viivytyksettä
            tarkastaa, että toimitus on sisältänyt hänen tilaamansa Tuotteet ja
            että Tuotteet ovat virheettömiä. Mikäli Asiakas havaitsee virheen,
            Asiakkaan tulee välittömästi ja viimeistään 7 päivän kuluessa
            tilauksen vastaanottamisesta ilmoittaa siitä Verkkokaupan
            asiakaspalveluun (puh: 040 1762979, sähköposti:
            asiakaspalvelu@Luomun tarina.fi).
          </p>
          <p>
            Toimituksessa tai Tuotteissa todetuissa kuluttajansuojalain
            tarkoittamissa viivästys- tai virhetilanteissa sovelletaan
            kuluttajansuojalain 5 luvun säännöksiä viivästyksen ja virheen
            seuraamuksista.
          </p>

          <h2>13. Ylivoimainen este</h2>
          <p>
            Yritys ei ole vastuussa sellaisesta Tuotteen virheellisyydestä,
            toimituksen viivästymisestä tai muusta sopimusrikkomuksesta, joka
            johtuu Yrityksen vaikutusmahdollisuuksien ulkopuolella olevasta
            seikasta (force majeure). Tällaisessa viivästymistilanteessa Yritys
            noudattaa velvollisuuksiaan niin pian kuin se on kyseisessä
            tilanteessa mahdollista.
          </p>
          <h2>14. Evästeet</h2>
          <p>
            Asiakkaan päätelaitteelle voidaan toimittaa evästeitä ("cookies").
            Eväste on pieni tekstitiedosto, jonka avulla voidaan kerätä tietoja
            siitä, miten Verkkokauppaa käytetään, eli esimerkiksi milloin ja
            mitä Verkkokaupan sivuja Asiakas on selannut, mistä Asiakas on
            tullut Verkkokauppaan ja mitä selainta Asiakas käyttää. Evästeiden
            avulla saatu tieto on luonteeltaan anonyymiä, mutta evästeen avulla
            saatua tietoa on mahdollista liittää Asiakkaalta saatuihin
            henkilötietoihin.
          </p>
          <p>
            Evästeiden käytön tarkoituksena on analysoida ja kehittää
            Verkkokauppaa, jotta Kauppias voi palvella Asiakkaita entistä
            paremmin, sekä hyödyntää tietoja Verkkokaupan kävijämäärien
            tilastollisessa seurannassa ja erilaisessa Verkkokaupan toimintojen
            tehon mittauksessa. Evästeiden avulla kerättyä tietoa voidaan
            käyttää myös kohdennetun mainonnan tuottamiseen (myös ns.
            Retargeting).
          </p>
          <p>
            Retargeting-mainonnassa myös muilla verkkosivustoilla mainoksissa
            voi näkyä tuotteita, jotka liittyvät Asiakkaan käyttäytymiseen
            Verkkokaupassa. Yritys ei luovuta kerättyä tietoa kolmansien
            osapuolien markkinointikäyttöön.
          </p>
          <p>
            Asiakkaalla on mahdollisuus kytkeä evästeiden käyttö pois
            selainasetuksistaan tai poistamalla evästeet Verkkokaupassa
            asioinnin jälkeen, mutta tällä voi olla vaikutusta Verkkokaupan
            käyttömahdollisuuksiin sitä heikentävästi tai jopa sen kokonaan
            estäen.
          </p>
          <h2>15. Ehtojen muuttaminen</h2>
          <p>
            Yritys pidättää oikeuden muuttaa näitä Ehtoja. Tilauksiin
            sovelletaan niitä Ehtoja, jotka olivat voimassa Asiakkaan tehdessä
            tilauksen.
          </p>
          <h2>16. Sovellettava laki ja riitojenratkaisu</h2>
          <p>
            Näihin Ehtoihin sovelletaan Suomen lakia. Osapuolet pyrkivät
            ensisijaisesti neuvotteluteitse ratkaisemaan näistä Ehdoista tai
            niiden soveltamisesta aiheutuvat erimielisyydet. Mikäli neuvottelut
            eivät johda sovintoratkaisuun kohtuullisessa ajassa, erimielisyydet
            ratkaistaan ensiasteena Espoon käräjäoikeudessa. Kuluttaja-asiakas
            voi kuitenkin viedä erimielisyyden myös kotipaikkansa käräjäoikeuden
            tai kuluttajariitalautakunnan ratkaistavaksi.
          </p>
          <h2>17. Muut ehdot</h2>
          <p>
            Kuluttajansuojalain 6 luvun nojalla Asiakkaalla ei ole etämyynnin
            peruuttamisoikeutta tilatessaan elintarvikkeiden tai muiden
            päivittäistavaroiden yksittäisiä toimituksia Asiakkaan ilmoittamaan
            osoitteeseen.
          </p>
          <h2>18. Asiakaspalvelu</h2>
          <p>
            Asiakasta kehotetaan kaikissa mahdollisissa ongelmatilanteissa
            kääntymään Verkkokaupan asiakaspalvelun puoleen:
          </p>
          <p>
            puhelin: 040 1762979,<br />
            sähköposti: asiakaspalvelu@luomuntarina.fi
          </p>
          <h2>19. Verkkokaupan ylläpitäjä</h2>
          <p>Verkkokauppaa ylläpitää:</p>
          <p>Seulo Palvelut Oy/Luomun tarina</p>
          <p>Y-tunnus: 2231096-6</p>
          <p>Osoite: Juurakkotie 6, 00510, VANTAA</p>
          <p>puhelin: 040 1762979,</p>
          <p>sähköposti: asiakaspalvelu@Luomun tarina.fi</p>
        </div>
      </div>
    </div>

    <div class="l-col--side l-col--sideNavigation l-col--sideLeft">
      <!-- <img
        src="https://static.bambora.com/payform/banners/payform_row_single.png"
        alt=""
      /> -->
    </div>
  </div>
</div>
